import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = 'https://kqtdvskivkgbvsygleyw.supabase.co';
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImtxdGR2c2tpdmtnYnZzeWdsZXl3Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDgyOTAxMDgsImV4cCI6MjA2Mzg2NjEwOH0.-zQqeW1na_DQ5TQLfKtqB1l938EozuV2ekgFh7vKQIE';

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);

// SHA256 hash function for password verification
export async function sha256(message) {
  const msgBuffer = new TextEncoder().encode(message);
  const hashBuffer = await crypto.subtle.digest('SHA-256', msgBuffer);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  return hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
}
